import { Placeholder } from 'react-bootstrap';

const LoadingPlaceholder = () => (
  <div className="g-3 mt-8 mb-8">
    <Placeholder as="p" animation="glow">
      <Placeholder xs={12} />
    </Placeholder>
    <Placeholder as="p" animation="glow">
      <Placeholder xs={12} />
    </Placeholder>
  </div>
);

export default LoadingPlaceholder;
